import gsap from 'gsap'

export const enter = () => {
/*
	let el = document.querySelector('[data-animation="header-brand"]')

	if (!el) return

	el.style.opacity = 1

	let hotel = el.querySelector('[data-enter-word="hotel"]'),
		indigo = el.querySelector('[data-enter-word="indigo"]'),
		leeds = el.querySelector('[data-enter-word="leeds"]')

	gsap.set(hotel, { yPercent: -100, })
	gsap.set(indigo, { yPercent: -100, })
	gsap.set(leeds, { yPercent: 100, })

	if (window.scrollY < 200) {
		gsap.fromTo(hotel, { yPercent: -100 }, { yPercent: 0, duration: 0.6, })
		gsap.fromTo(indigo, { yPercent: -100 }, { yPercent: 0, delay: 0.2, duration: 0.8, })
		gsap.fromTo(leeds, { yPercent: 100 }, { yPercent: 0, delay: 0.4, duration: 0.8, })
	}

	setTimeout(() => {

		let hotel = el.querySelector('[data-word="hotel"]'),
			indigo = el.querySelector('[data-word="indigo"]'),
			leeds = el.querySelector('[data-word="leeds"]')

		gsap.fromTo(hotel, {
			yPercent: 0,
			immediateRender: false,
		}, {
			yPercent: -100,
			ease: 'none',
			overwrite: true,
			scrollTrigger: {
				trigger: document.querySelector('main'),
				start: '2 top',
				end: '+=200',
				scrub: true,
				// markers: true,
			}
		})

		gsap.fromTo(indigo, {
			yPercent: 0,
			immediateRender: false,
		}, {
			yPercent: -100,
			ease: 'none',
			overwrite: true,
			scrollTrigger: {
				trigger: document.querySelector('main'),
				start: '2 top',
				end: '+=200',
				scrub: true,
				// markers: true,
			}
		})

		gsap.fromTo(leeds, {
			yPercent: 0,
			immediateRender: false,
		}, {
			yPercent: 100,
			ease: 'none',
			overwrite: true,
			scrollTrigger: {
				trigger: document.querySelector('main'),
				start: '2 top',
				end: '+=200',
				scrub: true,
				// markers: true,
			}
		})
		console.log('o')
	}, 1000);
	*/
}

export default () => { }